module.exports = __webpack_public_path__ + "img/zjxm.bd4bb1db.svg";